<div class="container">
  <div class="bar-box w-depth">
    <div class="step-name">
      <div class="name">
        {{stepName | translate}}
      </div>
      <div class="progress-step-box">
        <div class="step-line" *ngFor="let step of steps; trackBy:stepsTrack">
          <div class="filled-line" [ngClass]="{active: currentStep >= step}"></div>
        </div>
      </div>
    </div>
    <div class="step-number">
      <div class="number-circle">
        <div class="number">
          {{currentStep}}
        </div>
      </div>
    </div>
  </div>
</div>
